export const validations = {
    required: 'Please complete this field',
    email: 'Please enter a valid adress mail',
    min_length:'This field must be more than 6 characters',
    phone: 'Please enter a valid phone number'
}